import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import * as TextManager from "../../../modules/languages/TextManager";

const style = {
    width: '100%',
    position: 'fixed',
    top: '0',
    height: '30px',
    zIndex: '100',
    background: 'black'
    //box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.05);
};


class TopbarLine extends PureComponent {

    render() {
        let text = '';

        if( this.props.userData && this.props.userData.data &&
            !this.props.userData.data.isAdmin && !this.props.userData.data.isManager) {
            text = TextManager.getCurrentTextResource().Text.hello + ", " + this.props.userData.data.name;
        }

        return (
            <div style={style}>
                <div style={{marginRight: '20px', marginTop: '5px', float: 'right', color: 'white', fontSize: '14px', fontWeight: '700'}}>
                    {text}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {userData: state.userData};
};

export default withRouter(connect(mapStateToProps)(TopbarLine))
